import { Component, OnInit, OnDestroy } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { GeneralService } from "src/app/Service/general.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-add-receipt",
  templateUrl: "./add-receipt.component.html",
  styleUrls: ["./add-receipt.component.scss"],
})
export class AddReceiptComponent implements OnInit, OnDestroy {
  currentUser: any;
  public quotation: FormGroup;
  isLRS: any;
  submitted: boolean = false;
  non_lrs_Services = [
    { label: "Basic Property Protection", name: "max_value", rates: "2065" },
    { label: "Essential Property Protection", name: "max_EPP", rates: "2065" },
    { label: "Village/Area Alert", name: "max_area_sub", rates: "3539" },
    {
      label: "Auction Alert (Village/Area)",
      name: "max_auction",
      rates: "1769",
    },
    {
      label: "Auction Alert (Per Taluka)",
      name: "max_auction_taluka",
      rates: "3539",
    },
    {
      label: "Auction Alert (Per District)",
      name: "max_auction_district",
      rates: "4129",
    },
    {
      label: "T.P. Alert Upcoming (Per Village/Area)",
      name: "max_tp_new_village",
      rates: "1769",
    },
    {
      label: "T.P. Alert Upcoming (Per Taluka)",
      name: "max_tp_new_taluka",
      rates: "2949",
    },
    {
      label: "T.P. Alert Upcoming (Per District)",
      name: "max_tp_new_district",
      rates: "4719",
    },
    {
      label: "T.P. Alert Existing (Per Village/Area)",
      name: "max_tp_village",
      rates: "1769",
    },
    {
      label: "T.P. Alert Existing (Per Taluka)",
      name: "max_tp_taluka",
      rates: "2949",
    },
    {
      label: "T.P. Alert Existing (Per District)",
      name: "max_tp_district",
      rates: "4719",
    },
    {
      label: "T.P. Alert Existing (Per Per TP Scheme)",
      name: "max_tp_scheme",
      rates: "5899",
    },
    {
      label: "Title Search (Per District)",
      name: "max_titlesearch",
      rates: "4129",
    },
    {
      label: "Aajni Jahernotice (Per District)",
      name: "max_AajniJaherNotice",
      rates: "2595",
    },
    {
      label: "Jahernotice Android Application (Per Mobile Number)",
      name: "mobileapplication",
      rates: "1769",
    },
    {
      label: "Registered Mobile Number (Per Mobile Number)",
      name: "mobileNumbers",
      rates: "1179",
    },
  ];
  lrs_Services = [
    { label: "7-12 & 8A Non Certified", name: "max_satbaraand8a", rates: "99" },
    {
      label: "7-12 & 8A Certified",
      name: "max_satbaraand8a_certi",
      rates: "299",
    },
    {
      label: "Property Card Non Certified",
      name: "max_propertycard",
      rates: "99",
    },
    {
      label: "Property Card Certified",
      name: "max_propertycard_certi",
      rates: "399",
    },
    { label: "Nondh number 6 Non Certified", name: "max_nondh6", rates: "50" },
    {
      label: "Nondh number 6 Certified",
      name: "max_nondh6_certi",
      rates: "99",
    },
    { label: "F-Form Non Certified", name: "max_fform", rates: "499" },
    { label: "F-Form Certified", name: "max_fform_certi", rates: "1499" },
    { label: "Part Plan Non Certified", name: "max_partplan", rates: "499" },
    { label: "Part Plan Certified", name: "max_partplan_certi", rates: "1799" },
    {
      label: "Zoning Certificate Certified",
      name: "max_zoningcertificate_certi",
      rates: "1499",
    },
    {
      label: "Jantri Rate(Last updated) Non Certified",
      name: "max_jantrirate2001",
      rates: "99",
    },
    {
      label: "Jantri Rate (For Year 2001) Certified",
      name: "max_jantrirate2_certi",
      rates: "1199",
    },
    { label: "Old 7-12 Non Certified", name: "max_oldsatbara", rates: "499" },
    {
      label: "Old 7-12 Certified",
      name: "max_oldsatbara_certi",
      rates: "1499",
    },
    {
      label: "Registered Search Report Certified",
      name: "max_registeredsearchreport_certi",
      rates: "1499",
    },
    { label: "Index copy Non Certified", name: "max_indexcopy", rates: "499" },
    {
      label: "Index copy Certified",
      name: "max_indexcopy_certi",
      rates: "899",
    },
    {
      label: "Dastavej / Sales Deed Certified",
      name: "max_dastavej_certi",
      rates: "2499",
    },
    {
      label: "Govt. Certified Copy of Order Certified",
      name: "max_govcertifiedorder_certi",
      rates: "2499",
    },
    {
      label: "iProperty Verification Report (iPVR) Non Certified",
      name: "max_iPVR",
      rates: "2499",
    },
    { label: "KYS Non Certified", name: "max_KYS", rates: "999" },
  ];
  isRateZero: boolean;
  paymentType: any;
  ReceiptType: any = [];
  District: any = [];
  isLoading: boolean;
  /* Receipt-generation progress (staged/time-based estimate — see startReceiptProgress). */
  progress: number = 0;
  progressStage: string = '';
  private progressTimer: any = null;
  userId: any;
  breadCrumbItems: (
    | { label: string; path: string; active?: undefined }
    | { label: string; path: string; active: boolean }
  )[];
  user: any;
  invalid: boolean;
  /* ── Land Record order prefill ("Generate Receipt" from View Receipts) ── */
  adhocDeliveryId: any = null;
  landRecordOrder: any = null;
  orderPrefill: any = null;
  orderPrefillLoading: boolean = false;
  orderPrefillError: string = null;
  constructor(
    private service: GeneralService,
    private Fb: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    if (this.router.getCurrentNavigation()) {
      if (this.router.getCurrentNavigation().extras.state) {
        const state = this.router.getCurrentNavigation().extras.state;
        this.userId = state["UserId"];
        localStorage.setItem("UserId", this.userId);
        if (state["AdhocDeliveryID"]) {
          this.adhocDeliveryId = state["AdhocDeliveryID"];
          localStorage.setItem("AdhocDeliveryID", String(this.adhocDeliveryId));
        }
      } else {
        if (
          localStorage.getItem("UserId") !== undefined &&
          localStorage.getItem("UserId") !== null
        ) {
          this.userId = localStorage.getItem("UserId");
        }
      }
    }
    /* Page refresh on the Add page loses router state — fall back to the id
       stored by "Generate Receipt". Plain "Add Receipt" clears this key. */
    if (!this.adhocDeliveryId && localStorage.getItem("AdhocDeliveryID")) {
      this.adhocDeliveryId = localStorage.getItem("AdhocDeliveryID");
    }
  }

  ngOnInit() {
    this.currentUser = this.service.getcurrentUser();
    this.breadCrumbItems = [
      // { label: 'Users', path: '/users/users-users-details' },
      { label: "Receipts", path: "/users/users-users-details/receipts" },
      {
        label: "Add",
        path: "/users/users-users-details/receipts/add" + this.userId + "/add",
        active: true,
      },
    ];
    this.getusersbyid();
    this.service.getDistrict().subscribe(
      (Response: any) => {
        this.District = Response.data;
        /* A Land Record prefill may have arrived before the list — apply it now. */
        this.applyPrefillDistrict();
      },
      (error) => {
        //Error callback
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      }
    );
    this.service.getReceiptType().subscribe(
      (Response: any) => {
        this.ReceiptType = Response.result;
        console.log("ReceiptType", this.ReceiptType);
      },
      (error) => {
        //Error callback
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      }
    );
    this.quotation = this.Fb.group({
      ultimatePP: new FormControl(1, Validators.required),
      titleSearch: new FormControl(1, Validators.required),
      plan_name: new FormControl(""),
      group: new FormControl(0, Validators.required),
      is_active: new FormControl(1, Validators.required),
      userID: new FormControl(Number(this.userId), Validators.required),
      todaysNotice: new FormControl(1, Validators.required),
      findLawyer: new FormControl(1, Validators.required),
      findBroker: new FormControl(1, Validators.required),
      jantriRates: new FormControl(1, Validators.required),
      jaminBuySell: new FormControl(1, Validators.required),
      profitableInvestment: new FormControl(0, Validators.required),
      price: new FormControl(0, [
        Validators.required,
        Validators.pattern("^-?[0-9]*$"),
      ]),
      discount: new FormControl({ value: "0.00 %", disabled: true }),
      sub_total: new FormControl(
        { value: null, disabled: true },
        Validators.required
      ),
      is_LRS: new FormControl(null, Validators.required),
      pickup_date: new FormControl(null, Validators.required),
      pickup_address: new FormControl(null, Validators.required),
      message: new FormControl(""),
      district: new FormControl(null, Validators.required),
      receipt_date: new FormControl(null, Validators.required),
      start_date: new FormControl(null, Validators.required),
      end_date: new FormControl(null, Validators.required),
      payment_type: new FormControl(null, Validators.required),
      account_no: new FormControl("--"),
      account_holder_name: new FormControl("--"),
      bank_name: new FormControl("--"),
      NEFT_date: new FormControl(""),
      utrNo: new FormControl("--"),
      chequeNo: new FormControl("--"),
      chequeDate: new FormControl(""),
      branchName: new FormControl("--"),
      transaction_id: new FormControl("--"),
      bill_to_name: new FormControl(null, [
        Validators.required,
        Validators.pattern("^.*[a-zA-Z0-9]+.*$"),
      ]),
      bill_to_address: new FormControl(null, Validators.required),
      receipt_type: new FormControl(null, Validators.required),
      receipt_type_name: new FormControl(null),
      gst_no: new FormControl(null),
      is_quotation: new FormControl(true, Validators.required),
      isIGST: new FormControl(false, Validators.required),
      /* Land Record order this receipt is generated for (payment_reciept.AdhocDeliveryID); null for normal receipts */
      AdhocDeliveryID: new FormControl(null),
      /* CSR generating the receipt (tblAdminUser.Id → payment_reciept.CreatedBy) — all receipt types */
      CreatedBy: new FormControl(
        this.currentUser && this.currentUser.Id ? Number(this.currentUser.Id) : null
      ),
    });
    this.quotation.addControl(`max_zoningcertificate`, new FormControl(0));
    this.quotation.addControl(
      `max_zoningcertificate_rates`,
      new FormControl(`0.00`, [
        Validators.required,
        Validators.pattern("^[0-9.]*$"),
      ])
    );
    this.quotation.addControl(
      `max_zoningcertificate_Total`,
      new FormControl("0.00")
    );
    this.quotation.addControl(`max_dastavej`, new FormControl(0));
    this.quotation.addControl(
      `max_dastavej_rates`,
      new FormControl(`0.00`, [
        Validators.required,
        Validators.pattern("^[0-9.]*$"),
      ])
    );
    this.quotation.addControl(`max_dastavej_Total`, new FormControl("0.00"));
    this.quotation.addControl(`max_govcertifiedorder`, new FormControl(0));
    this.quotation.addControl(
      `max_govcertifiedorder_rates`,
      new FormControl(`0.00`, [
        Validators.required,
        Validators.pattern("^[0-9.]*$"),
      ])
    );
    this.quotation.addControl(
      `max_govcertifiedorder_Total`,
      new FormControl("0.00")
    );
    this.quotation.addControl(`max_jantrirate2`, new FormControl(0));
    this.quotation.addControl(
      `max_jantrirate2_rates`,
      new FormControl(`0.00`, [
        Validators.required,
        Validators.pattern("^[0-9.]*$"),
      ])
    );
    this.quotation.addControl(`max_jantrirate2_Total`, new FormControl("0.00"));
    this.quotation.addControl(`max_jantriratenew_certi`, new FormControl(0));
    this.quotation.addControl(
      `max_jantriratenew_certi_rates`,
      new FormControl(`0.00`, [
        Validators.required,
        Validators.pattern("^[0-9.]*$"),
      ])
    );
    this.quotation.addControl(
      `max_jantriratenew_certi_Total`,
      new FormControl("0.00")
    );
    this.quotation.addControl(`max_registeredsearchreport`, new FormControl(0));
    this.quotation.addControl(
      `max_registeredsearchreport_rates`,
      new FormControl(`0.00`, [
        Validators.required,
        Validators.pattern("^[0-9.]*$"),
      ])
    );
    this.quotation.addControl(
      `max_registeredsearchreport_Total`,
      new FormControl("0.00")
    );
    this.non_lrs_Services.forEach((element) => {
      this.quotation.addControl(
        `${element.name}`,
        new FormControl(0, [Validators.pattern("^[0-9]*$")])
      );
      this.quotation.addControl(
        `${element.name}_rates`,
        new FormControl(`${element.rates}`, [
          Validators.required,
          Validators.pattern("^[0-9.]*$"),
        ])
      );
      this.quotation.addControl(
        `${element.name}_Total`,
        new FormControl({ value: "0.00", disabled: true })
      );
    });
    this.lrs_Services.forEach((element) => {
      this.quotation.addControl(
        `${element.name}`,
        new FormControl(0, [Validators.pattern("^[0-9]*$")])
      );
      this.quotation.addControl(
        `${element.name}_rates`,
        new FormControl(`${element.rates}`, [
          Validators.required,
          Validators.pattern("^[0-9.]*$"),
        ])
      );
      this.quotation.addControl(
        `${element.name}_Total`,
        new FormControl({ value: "0.00", disabled: true })
      );
    });

    if (this.adhocDeliveryId) {
      /* Link the receipt to the order up front — independent of whether the
         prefill call below succeeds — so payment_reciept.AdhocDeliveryID is
         never NULL for a receipt generated from a Land Record order. */
      this.quotation.controls.AdhocDeliveryID.setValue(
        Number(this.adhocDeliveryId)
      );
      this.loadLandRecordOrderPrefill();
    }
  }

  /* ═══════════════════════════════════════════════════════════════════════
     Land Record order → prefill
     ═══════════════════════════════════════════════════════════════════════ */

  /** Fetches the order (tblUserAdhocDelivery) and prefills the form from it. */
  loadLandRecordOrderPrefill() {
    this.orderPrefillLoading = true;
    this.orderPrefillError = null;
    this.service
      .getLandRecordOrderReceiptPrefill(this.adhocDeliveryId)
      .subscribe(
        (res: any) => {
          this.orderPrefillLoading = false;
          if (!res || res.status !== 200 || !res.data) {
            this.orderPrefillError =
              (res && res.message) || "Land Record order could not be loaded.";
            return;
          }
          if (
            res.data.order &&
            Number(res.data.order.UserID) !== Number(this.userId)
          ) {
            this.orderPrefillError =
              "This Land Record order belongs to a different user.";
            this.adhocDeliveryId = null;
            localStorage.removeItem("AdhocDeliveryID");
            this.quotation.controls.AdhocDeliveryID.setValue(null);
            return;
          }
          this.applyLandRecordOrderPrefill(res.data);
        },
        (error) => {
          this.orderPrefillLoading = false;
          this.orderPrefillError =
            (error && error.error && error.error.message) ||
            "Land Record order could not be loaded.";
        }
      );
  }

  /** Puts the order data into the form: receipt type, services, payment, bill-to, dates. */
  private applyLandRecordOrderPrefill(data: any) {
    this.orderPrefill = data;
    this.landRecordOrder = data.order;

    this.quotation.controls.AdhocDeliveryID.setValue(
      Number(this.adhocDeliveryId)
    );

    /* 1. Receipt Type → "Land Record" (id 1) and switch to the LRS service list.
          setLRS() resets all quantities, so it must run BEFORE the services are filled. */
    const receiptTypeId = data.receiptTypeId != null ? data.receiptTypeId : 1;
    this.quotation.controls.receipt_type.setValue(receiptTypeId);
    this.setLRS(receiptTypeId);

    /* 2. Services — quantity / price / amount for every mapped order line. */
    (data.receiptServices || []).forEach((svc) => {
      const qtyCtrl = this.quotation.controls[svc.field];
      const rateCtrl = this.quotation.controls[`${svc.field}_rates`];
      if (!qtyCtrl || !rateCtrl) {
        return;
      }
      qtyCtrl.setValue(Number(svc.qty) || 0);
      rateCtrl.setValue(String(svc.price != null ? svc.price : 0));
      this.Calculate(svc.field);
    });

    /* 3. Payment — only when the customer already paid on the website. */
    if (data.paymentType) {
      this.quotation.controls.payment_type.setValue(data.paymentType);
      this.onchangePaymentType(data.paymentType);
      if (
        data.transactionId &&
        (data.paymentType === "upi" || data.paymentType === "razorpay")
      ) {
        this.quotation.controls.transaction_id.setValue(data.transactionId);
      }
    }

    /* 4. Bill-to details from the order (user defaults stay when the order has none). */
    this.applyOrderBillingDetails();

    /* 5. Dates — a Land Record receipt is a one-off document delivery, not a
          subscription, so Receipt Date, Start Date and End Date are all the same
          day (payment/order date). The +1 year End Date rule is NOT applied here. */
    /* The order date is an MSSQL datetime stored in IST but sent with a 'Z' (UTC)
       suffix — take its UTC date so it is the exact stored day (no +5:30 shift). */
    const baseDate = data.paymentDate ? new Date(data.paymentDate) : null;
    const isoDate =
      baseDate && !isNaN(baseDate.getTime())
        ? baseDate.toISOString().slice(0, 10)
        : this.toISODate(new Date());
    this.quotation.controls.receipt_date.setValue(isoDate);
    this.quotation.controls.start_date.setValue(isoDate);
    this.quotation.controls.end_date.setValue(isoDate);
    if (!this.quotation.controls.pickup_date.value) {
      this.quotation.controls.pickup_date.setValue(isoDate);
    }
  }

  /**
   * Billing / pickup prefill for a Land Record order.
   *   - Pickup Address, District and Bill to Address ALWAYS come from the district the
   *     customer selected for the order (village → taluka → district).
   *   - GST No.: from the order if recorded, else from the user's latest receipt.
   *   - Bill To Name: from the order if recorded, else the user's name (getusersbyid).
   * Called from both async callbacks so the result is the same whichever arrives last.
   */
  private applyOrderBillingDetails() {
    if (!this.orderPrefill) {
      return;
    }
    const p = this.orderPrefill;
    const prev = p.previousReceipt;
    const districtName = p.district && p.district.name ? String(p.district.name).trim() : "";

    if (districtName) {
      this.quotation.controls.pickup_address.setValue(districtName);
      this.quotation.controls.bill_to_address.setValue(districtName);
    } else if (prev) {
      /* order has no district (e.g. village missing) → fall back to the last receipt */
      if (prev.pickupAddress) {
        this.quotation.controls.pickup_address.setValue(prev.pickupAddress);
      }
      if (prev.billToAddress) {
        this.quotation.controls.bill_to_address.setValue(prev.billToAddress);
      }
    }
    this.applyPrefillDistrict();

    if (prev && prev.gstNo) {
      this.quotation.controls.gst_no.setValue(prev.gstNo);
    }
    if (p.billToName) {
      this.quotation.controls.bill_to_name.setValue(p.billToName);
    }
    if (p.gstNo) {
      this.quotation.controls.gst_no.setValue(p.gstNo);
    }
  }

  /**
   * District for a Land Record order: the district selected on the order; if the order
   * has none, the user's previous receipt. Set ONLY when that id exists in the loaded
   * District list, so ng-select always has a name to display. If the list is not loaded
   * yet, failed, or lacks the id, the field is left blank for the CSR.
   */
  private applyPrefillDistrict() {
    if (!this.orderPrefill) {
      return;
    }
    const p = this.orderPrefill;
    const districtId = Number(
      (p.district && p.district.id) ||
        (p.previousReceipt && p.previousReceipt.districtId) ||
        0
    );
    if (!districtId || !Array.isArray(this.District) || !this.District.length) {
      return;
    }
    const known = this.District.some((d) => Number(d.ID) === districtId);
    this.quotation.controls.district.setValue(known ? districtId : null);
  }

  private toISODate(d: Date) {
    const pad = (n) => (n < 10 ? "0" + n : "" + n);
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  }

  Calculate(name) {
    if (this.submitted == true && this.invalid === false) {
      return;
    }
    this.quotation.controls[`${name}_Total`].setValue(
      this.quotation.controls[`${name}`].value *
        this.quotation.controls[`${name}_rates`].value
    );
    let Total = 0;
    if (this.isLRS === 0) {
      this.non_lrs_Services.forEach((element) => {
        Total =
          Number(Total) +
          Number(this.quotation.controls[`${element.name}_Total`].value);
      });
    } else if (this.isLRS === 1) {
      this.lrs_Services.forEach((element) => {
        Total =
          Number(Total) +
          Number(this.quotation.controls[`${element.name}_Total`].value);
      });
    }
    this.quotation.controls.sub_total.setValue(Math.floor(Number(Total)));
    this.quotation.controls.price.setValue(Math.floor(Number(Total)));
    this.CalculateDiscount();
  }
  CalculateDiscount() {
    if (this.quotation.controls.sub_total.value === null) {
      return;
    }
    this.quotation.controls.discount.setValue(
      Number(
        (Number(
          this.quotation.controls.sub_total.value -
            this.quotation.controls.price.value
        ) *
          100) /
          Number(this.quotation.controls.sub_total.value)
      ).toFixed(2) + "%"
    );
    this.setPlan(Number(this.quotation.controls.price.value));
  }
  onchange(id) {
    this.isLRS = id;
    this.resetForm();
  }
  onSubmit() {
    this.submitted = true;
    this.invalid = false;
    this.isRateZero = false;
    this.non_lrs_Services.forEach((element) => {
      if (
        this.quotation.controls[`${element.name}`].value == "" ||
        this.quotation.controls[`${element.name}`].value == null
      ) {
        this.quotation.controls[`${element.name}`].setValue(0);
      }
      if (Number(element.rates) <= 0) {
        this.isRateZero = true;
      }
    });
    this.lrs_Services.forEach((element) => {
      if (
        this.quotation.controls[`${element.name}`].value == "" ||
        this.quotation.controls[`${element.name}`].value == null
      ) {
        this.quotation.controls[`${element.name}`].setValue(0);
      }
      if (Number(element.rates) <= 0) {
        this.isRateZero = true;
      }
    });
    this.save();
  }
  setPlan(value) {
    var plan;
    if (value < 1500) {
      plan = "IC-BRONZE";
    } else if (value >= 1500 && value <= 3300) {
      plan = "IC-SHINE";
    } else if (value > 3300 && value <= 5300) {
      plan = "IC-GOLD";
    } else if (value > 5300 && value <= 7800) {
      plan = "GC-PLATINUM";
    } else if (value > 7800 && value <= 14800) {
      plan = "GC-DIAMOND";
    } else if (value > 14800) {
      plan = "GC-PEARL";
    }
    this.quotation.controls.plan_name.setValue(plan);
  }
  save() {
    if (this.quotation.controls.receipt_type.valid) {
      this.ReceiptType.forEach((i) => {
        if (i.id === this.quotation.controls.receipt_type.value) {
          this.quotation.controls.receipt_type_name.setValue(i.receipt_type);
        }
      });
    }
    if (this.quotation.controls.pickup_address.valid) {
      this.quotation.controls.pickup_address.setValue(
        this.quotation.controls.pickup_address.value.trim()
      );
    }
    if (this.quotation.controls.bill_to_address.valid) {
      this.quotation.controls.bill_to_address.setValue(
        this.quotation.controls.bill_to_address.value.trim()
      );
    }

    if (
      this.quotation.invalid ||
      Number(this.quotation.controls.price.value) <= 0 ||
      Number(this.quotation.controls.sub_total.value) <= 0 ||
      Number(this.quotation.controls.sub_total.value) <
        Number(this.quotation.controls.price.value) ||
      this.isRateZero == true
    ) {
      this.invalid = true;
      return;
    }
    this.quotation.controls.price.setValue(
      Number(this.quotation.controls.price.value)
    );
    if (this.quotation.controls.gst_no.value === null) {
      this.quotation.controls.gst_no.setValue("N/A");
    }
    this.isLoading = true;
    this.startReceiptProgress();
    this.quotation.controls.sub_total.enable();
    this.quotation.controls.discount.enable();
    this.non_lrs_Services.forEach((element) => {
      this.quotation.controls[`${element.name}_Total`].enable();
    });
    this.lrs_Services.forEach((element) => {
      this.quotation.controls[`${element.name}_Total`].enable();
    });

    this.service.AddReceipt(this.quotation.value).subscribe(
      (data) => {
        this.stopReceiptProgress(() => {
          this.isLoading = false;
          this.resetForm();
          if (data.status === 200) {
            this.submitted = false;
            /* Receipt for the Land Record order is done — drop the prefill key.
               If Generate Receipt was started from the Land Record Orders screen,
               go back there; otherwise to the user's View Receipts as before. */
            localStorage.removeItem("AdhocDeliveryID");
            const returnTo = localStorage.getItem("ReceiptReturnTo");
            localStorage.removeItem("ReceiptReturnTo");
            Swal.fire({
              title: "Receipt Added",
              text: data.message,
              type: "success",
            }).then(() => {
              this.submitted = false;
              this.router.navigate([
                returnTo === "land-record-orders"
                  ? "/users/land-record-orders"
                  : "/users/users-users-details/receipts",
              ]);
            });
          } else {
            Swal.fire({
              title: data.error_code,
              text: data.message,
              type: "error",
            });
          }
        });
      },
      (error) => {
        //Error callback
        this.stopReceiptProgress(() => {
          this.isLoading = false;
          /* 400/404/409 from the order validation carry a specific message
             (e.g. receipt already generated for this order) — show it instead
             of a generic 500 text. */
          const serverMessage =
            error && error.error && error.error.message
              ? error.error.message
              : null;
          Swal.fire({
            title: error.status,
            text:
              serverMessage && error.status !== 500
                ? serverMessage
                : "Internal Server Error",
            type: "error",
          });
        });
        //throw error;   //You can also throw the error to a global error handler
      }
    );
  }

  /**
   * Drives the receipt-generation progress bar.
   *
   * NOTE: this is a STAGED, TIME-BASED ESTIMATE, not a live server feed — the
   * generate API is a single request that does not stream progress. The stage
   * labels mirror the real backend phases (PDF generation → save → e-mails).
   * Progress eases toward 95% and holds there until the server actually
   * responds, at which point stopReceiptProgress() snaps it to 100%. This gives
   * the CSR team clear "it's working" feedback without a fake early completion.
   */
  private startReceiptProgress() {
    this.progress = 0;
    this.progressStage = "Preparing data…";

    const stages = [
      { until: 15, label: "Preparing data…" },
      { until: 65, label: "Generating Quotation, Receipt & Invoice PDFs…" },
      { until: 82, label: "Saving records…" },
      { until: 96, label: "Sending emails…" },
    ];

    if (this.progressTimer) { clearInterval(this.progressTimer); }
    this.progressTimer = setInterval(() => {
      if (this.progress < 95) {
        // Slows as it nears the 95% cap so it never appears "done" early.
        const remaining = 95 - this.progress;
        this.progress += Math.max(0.4, remaining * 0.04);
        if (this.progress > 95) { this.progress = 95; }
      }
      const stage = stages.find((s) => this.progress < s.until) || stages[stages.length - 1];
      this.progressStage = stage.label;
    }, 250);
  }

  /** Completes the progress bar (100%), briefly shows it, then runs `done`. */
  private stopReceiptProgress(done: () => void) {
    if (this.progressTimer) { clearInterval(this.progressTimer); this.progressTimer = null; }
    this.progress = 100;
    this.progressStage = "Completed";
    setTimeout(() => {
      done();
      this.progress = 0;
      this.progressStage = "";
    }, 500);
  }

  ngOnDestroy() {
    // Prevent the progress interval from running after the view is gone.
    if (this.progressTimer) { clearInterval(this.progressTimer); this.progressTimer = null; }
  }
  resetForm() {
    this.submitted = false;
    this.invalid = false;
    this.non_lrs_Services.forEach((element) => {
      this.quotation.controls[`${element.name}`].setValue(0);
      this.quotation.controls[`${element.name}_rates`].setValue(element.rates);
      this.quotation.controls[`${element.name}_Total`].setValue(0.0);
      this.quotation.controls.todaysNotice.setValue(1);
      this.quotation.controls.findLawyer.setValue(1);
      this.quotation.controls.findBroker.setValue(1);
      this.quotation.controls.jantriRates.setValue(1);
      this.quotation.controls.jaminBuySell.setValue(1);
      this.quotation.controls.profitableInvestment.setValue(1);
      this.quotation.controls[`${element.name}_Total`].disable();
    });
    this.lrs_Services.forEach((element) => {
      this.quotation.controls[`${element.name}`].setValue(0);
      this.quotation.controls[`${element.name}_rates`].setValue(element.rates);
      this.quotation.controls[`${element.name}_Total`].setValue(0.0);
      this.quotation.controls[`${element.name}_Total`].disable();
    });
    this.quotation.controls.discount.setValue("0.00 %");
    this.quotation.controls.price.setValue(0);
  }
  onchangePaymentType(type) {
    this.paymentType = type;
    this.quotation.controls["chequeNo"].setValue("--");
    this.quotation.controls["chequeDate"].setValue("");
    this.quotation.controls["account_no"].setValue("--");
    this.quotation.controls["account_holder_name"].setValue("--");
    this.quotation.controls["bank_name"].setValue("--");
    this.quotation.controls["branchName"].setValue("--");
    this.quotation.controls["NEFT_date"].setValue("");
    this.quotation.controls["utrNo"].setValue("--");
    this.quotation.controls["transaction_id"].setValue("--");
    this.quotation.controls["chequeNo"].clearValidators();
    this.quotation.controls["chequeDate"].clearValidators();
    this.quotation.controls["account_no"].clearValidators();
    this.quotation.controls["account_holder_name"].clearValidators();
    this.quotation.controls["bank_name"].clearValidators();
    this.quotation.controls["branchName"].clearValidators();
    this.quotation.controls["NEFT_date"].clearValidators();
    this.quotation.controls["utrNo"].clearValidators();
    this.quotation.controls["transaction_id"].clearValidators();
    this.submitted = false;
    this.isLoading = true;
    if (this.paymentType == "cheque") {
      this.quotation.controls["chequeNo"].setValidators([
        Validators.required,
        Validators.pattern("^.*[a-zA-Z0-9]+.*$"),
      ]);
      this.quotation.controls["chequeDate"].setValidators([
        Validators.required,
        Validators.pattern("^.*[a-zA-Z0-9]+.*$"),
      ]);
      this.quotation.controls["account_no"].setValidators([
        Validators.required,
        Validators.pattern("^.*[a-zA-Z0-9]+.*$"),
      ]);
      this.quotation.controls["bank_name"].setValidators([
        Validators.required,
        Validators.pattern("^.*[a-zA-Z0-9]+.*$"),
      ]);
      this.quotation.controls["branchName"].setValidators([
        Validators.required,
        Validators.pattern("^.*[a-zA-Z0-9]+.*$"),
      ]);
      this.quotation.controls["chequeNo"].setValue(null);
      this.quotation.controls["chequeDate"].setValue(null);
      this.quotation.controls["account_no"].setValue(null);
      this.quotation.controls["bank_name"].setValue(null);
      this.quotation.controls["branchName"].setValue(null);
    } else if (this.paymentType == "NEFT") {
      this.quotation.controls["account_holder_name"].setValidators([
        Validators.required,
        Validators.pattern("^.*[a-zA-Z0-9]+.*$"),
      ]);
      this.quotation.controls["NEFT_date"].setValidators([
        Validators.required,
        Validators.pattern("^.*[a-zA-Z0-9]+.*$"),
      ]);
      this.quotation.controls["account_no"].setValidators([
        Validators.required,
        Validators.pattern("^.*[a-zA-Z0-9]+.*$"),
      ]);
      this.quotation.controls["bank_name"].setValidators([
        Validators.required,
        Validators.pattern("^.*[a-zA-Z0-9]+.*$"),
      ]);
      this.quotation.controls["utrNo"].setValidators([
        Validators.required,
        Validators.pattern("^.*[a-zA-Z0-9]+.*$"),
      ]);
      this.quotation.controls["account_holder_name"].setValue(null);
      this.quotation.controls["NEFT_date"].setValue(null);
      this.quotation.controls["account_no"].setValue(null);
      this.quotation.controls["bank_name"].setValue(null);
      this.quotation.controls["utrNo"].setValue(null);
    } else if (this.paymentType == "upi" || this.paymentType == "razorpay") {
      this.quotation.controls["transaction_id"].setValidators([
        Validators.required,
        Validators.pattern("^.*[a-zA-Z0-9]+.*$"),
      ]);
      this.quotation.controls["transaction_id"].setValue(null);
    }
    this.quotation.controls["chequeNo"].updateValueAndValidity();
    this.quotation.controls["chequeDate"].updateValueAndValidity();
    this.quotation.controls["account_no"].updateValueAndValidity();
    this.quotation.controls["bank_name"].updateValueAndValidity();
    this.quotation.controls["branchName"].updateValueAndValidity();
    this.quotation.controls["account_holder_name"].updateValueAndValidity();
    this.quotation.controls["NEFT_date"].updateValueAndValidity();
    this.quotation.controls["utrNo"].updateValueAndValidity();
    this.quotation.controls["transaction_id"].updateValueAndValidity();
    this.isLoading = false;
  }
  get f() {
    return this.quotation.controls;
  }
  SetEndDate() {
    var date = new Date(this.quotation.controls.start_date.value);
    this.quotation.controls.end_date.setValue(
      this.add_years(date, 1).toISOString().substr(0, 10)
    );
  }
  add_years(dt, n) {
    return new Date(dt.setFullYear(dt.getFullYear() + n));
  }
  getusersbyid() {
    this.service.getusersbyid(this.userId).subscribe(
      (res: any) => {
        this.user = res.data[0];
        this.user.mobileno = this.user.MobileNo.split(",");
        this.user.email = this.user.EmailID.split(",");
        this.quotation.controls.bill_to_address.setValue(
          `${
            this.user.add1 != "null" && this.user.add1 != null
              ? this.user.add1
              : ""
          } ${
            this.user.add2 != "null" && this.user.add2 != null
              ? this.user.add2
              : ""
          }`.trim()
        );
        this.quotation.controls.pickup_address.setValue(
          `${
            this.user.add1 != "null" && this.user.add1 != null
              ? this.user.add1
              : ""
          } ${
            this.user.add2 != "null" && this.user.add2 != null
              ? this.user.add2
              : ""
          }`.trim()
        );
        this.quotation.controls.bill_to_name.setValue(
          `${this.user.FirstName} ${this.user.LastName}`
        );
        /* If a Land Record order prefill already landed, its bill-to wins. */
        this.applyOrderBillingDetails();
      },
      (error) => {
        //Error callback
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      }
    );
  }
  setLRS(id) {
    if (id == 1) {
      this.quotation.controls.is_LRS.setValue(1);
      this.onchange(1);
    } else if (id == undefined) {
      this.quotation.controls.is_LRS.setValue(1);
      this.onchange(null);
    } else {
      this.quotation.controls.is_LRS.setValue(0);
      this.onchange(0);
    }
  }
}
